import { useEffect, type MouseEventHandler } from 'react'
import { observer } from 'mobx-react'
import useRepository from '@/hooks/useRepository'

import { S } from './ContractModal.style'
import { ContractModalService } from './ContractModal.service'
import { useHistory } from 'react-router'
import ContractStep1 from './components/ContractStep1'
import ContractStep2 from './components/ContractStep2'
import ContractStep3 from './components/ContractStep3'

export type ModalProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const ContractModal = ({ onClick }: ModalProps) => {
  const history = useHistory()
  const service = useRepository(ContractModalService)

  // 계약서 팝업이 떴을때 브라우저 뒤로가기 막기
  useEffect(() => {
    const disposeBlocker = history.block((_, action) => {
      if (action === 'POP') {
        return false
      }
    })

    window.onbeforeunload = (event) => {
      event.preventDefault()
    }
    return () => {
      disposeBlocker()
      window.onbeforeunload = null
    }
  }, [])

  return (
    <>
      {service.uiStore.currentStep !== 3 && (
        <S.Modal>
          <div className="modal-header">
            <h1>스쿨플랫 정식 가입 계약 내역서</h1>
          </div>
          {service.uiStore.currentStep === 1 && <ContractStep1 />}
          {service.uiStore.currentStep === 2 && <ContractStep2 />}
        </S.Modal>
      )}

      {service.uiStore.currentStep === 3 && <ContractStep3 onClick={onClick} />}
    </>
  )
}

export default observer(ContractModal)
